export enum RequestsAndLicensesTab{
  licenses = 0,
  requests = 1,
}
